<template>
    <div>
        <div id="hello-hello">
            <p style="display:inline;float: left;line-height: 22px;"><b>设备列表</b></p>
            <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                <el-button type="primary" round @click="openDialog">添加设备</el-button>
            </p>
        </div>

        <el-table :data="equipmentList" style="width: 100%">
            <el-table-column prop="equipmentCode" label="设备编号" min-width="30%">
            </el-table-column>
            <el-table-column prop="equipmentName" label="设备名称" min-width="30%">
            </el-table-column>

            <el-table-column prop="ipAddress" label="ip地址" min-width="20%">
            </el-table-column>
            <el-table-column prop="statusDes" label="设备状态" min-width="20%">
            </el-table-column>
            <el-table-column prop="macAddress" label="mac地址" v-if="false">
            </el-table-column>
            
            <el-table-column fixed="right" label="操作" width="330">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="success" round size="small">
                        更改
                    </el-button>
                    <el-button @click="changeClick(scope.row)" type="success" round size="small">
                        更改状态
                    </el-button>
                    <el-button @click="printClick(scope.row)" type="success" round size="small">
                        打印维码
                    </el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div>
            <el-pagination background :page-size="pageNum" :page-count="pageCount" layout="total, sizes, prev, pager, next"
                :total="total" @current-change="pageClick" :page-sizes="[10, 15, 20, 25]" @size-change="handleSizeChange">
            </el-pagination>
        </div>

        <el-dialog title="设备详情" :visible.sync="dlgFormVisible" width="25%">
            <el-form :model="form" :rules="rules" class="demo-ruleForm" ref="ruleForm">
                <el-form-item label="设备编号" :label-width="formLabelWidth" prop="equipmentCode">
                    <el-input v-model="form.equipmentCode" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="设备名称" :label-width="formLabelWidth" prop="equipmentName">
                    <el-input v-model="form.equipmentName" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>

                <el-form-item label="mac地址" :label-width="formLabelWidth">
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span><el-input v-model="form.macAddress" autocomplete="off"
                        style="width:300px"></el-input>
                </el-form-item>
                <el-form-item label="ip地址" :label-width="formLabelWidth">
                    &nbsp;<el-input v-model="form.ipAddress" autocomplete="off" style="width:300px"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addEquipment('ruleForm')">保 存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="设备状态" :visible.sync="statusDlgVisible" width="50%">
            <el-tag type="danger">当前选择的设备编号：{{ form.equipmentCode }}</el-tag>
            <p>
                <el-radio-group v-model="form.status">
                    <el-radio :label="1">待机</el-radio>
                    <el-radio :label="2">生产</el-radio>
                    <el-radio :label="3">检修</el-radio>
                    <el-radio :label="4">暂停</el-radio>
                    <el-radio :label="5">试模</el-radio>
                </el-radio-group>
            </p>

            <div slot="footer" class="dialog-footer">
                <el-button @click="statusDlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="modifyEquipStatus">保 存</el-button>
            </div>
        </el-dialog>

        <el-dialog title="打印二维码" :visible.sync="printDlgVisible" width="50%">
            <!-- <el-image style="width: 100px; height: 100px" :src="barcodeUrl" :fit="fit"></el-image> -->
            <div id="barcode-img" v-html="barcodeUrl"></div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="printDlgVisible = false">取 消</el-button>
                <el-button type="primary" @click="printBarcode(1)">打 印</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "EquipmentManage",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            imagePath: this.getImagePath(),
            
            equipmentList: [],
            dlgFormVisible: false,
            statusDlgVisible: false,
            printDlgVisible: false,
            form: {
                id: '',
                equipmentCode: '',
                equipmentName: '',
                macAddress: '',
                ipAddress: '',
                status: ''
            },
            rules: {
                equipmentCode: [{
                    required: true, message: '请输入设备编号', trigger: 'blur'
                }],
                equipmentName: [{
                    required: true, message: '请输入设备名称', trigger: 'blur'
                }]
            },
            barcodeUrl: '',
            isAdd: true,

            pageIndex: 0,
            pageNum: 10,
            total: 0,
            pageCount: 0,
        }
    },
    methods: {
        openDialog() {
            this.form.id = ''

            this.form.equipmentCode = ''
            this.form.equipmentName = ''
            this.form.macAddress = ''
            this.form.ipAddress = ''
            
            this.dlgFormVisible = true
            this.isAdd = true
        },
        addEquipment(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //alert('submit!');
                    this.$axios({
                        method: "post",
                        url: "/shiro/equipment/add",
                        data: {
                            id: this.form.id,
                            equipmentCode: this.form.equipmentCode,
                            equipmentName: this.form.equipmentName,
                            macAddress: this.form.macAddress,
                            ipAddress: this.form.ipAddress,
                            status: this.form.status,
                            companyId: this.companyId
                        },
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status === 201) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                            return
                        }

                        this.getAll()

                        if (this.isAdd) {
                            this.$axios({
                                method: "post",
                                url: "/shiro/equipment/print",
                                data: {
                                    equipmentCode: this.form.equipmentCode,
                                    companyId: this.companyId
                                },
                                headers: {
                                    token: this.token
                                }
                            }).then(result => {})
                        }

                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })

        },
        modifyEquipStatus() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/status",
                data: {
                    id: this.form.id,
                    status: this.form.status,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 201) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                if (data.status === 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    this.statusDlgVisible = false
                }
            })
        },
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/equipment/getAll",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.equipmentList = data.data
                this.total = this.equipmentList[0].total
                for (let i in this.equipmentList) {
                    if (this.equipmentList[i].status == 1) {
                        this.equipmentList[i].statusDes = '待机'
                    } else if (this.equipmentList[i].status == 2) {
                        this.equipmentList[i].statusDes = '生产'
                    } else if (this.equipmentList[i].status == 3) {
                        this.equipmentList[i].statusDes = '检修'
                    } else if (this.equipmentList[i].status == 4){
                        this.equipmentList[i].statusDes = '暂停'
                    }else{
                        this.equipmentList[i].statusDes = '试模'
                    }
                }

                if (this.dlgFormVisible) {
                    this.dlgFormVisible = false
                } else {
                    this.statusDlgVisible = false
                }

            })
        },
        handleClick(row) {
            this.form.id = row.id

            this.dlgFormVisible = true
            this.isAdd = true

            this.form.equipmentCode = row.equipmentCode
            this.form.equipmentName = row.equipmentName
            this.form.macAddress = row.macAddress
            this.form.ipAddress = row.ipAddress
            this.form.status = row.status
        },
        changeClick(row) {

            this.form.id = row.id
            this.form.equipmentCode = row.equipmentCode
            this.form.equipmentName = row.equipmentName
            this.form.macAddress = row.macAddress
            this.form.ipAddress = row.ipAddress
            this.form.status = row.status
            //console.log(this.form.status)
            this.statusDlgVisible = true
            this.isAdd = false
        },
        printClick(row) {

            this.barcodeUrl = "<div>" + row.equipmentCode + "</div><img src='https://" + this.imagePath +
             this.companyId + "/equipment/barcode/" + row.equipmentCode + ".png'>"

            // this.barcodeUrl="<img src='/favicon.ico' style='height: 150px;width: 150px'/>"
            this.printDlgVisible = true
        },
        printBarcode(fang) {
            var content = document.getElementById("barcode-img").innerHTML
            // console.log(content)
            var sprnstr = "<!--startprint" + fang + "-->"
            var eprnstr = "<!--endprint" + fang + "-->"

            var iframe = document.createElement("IFRAME")

            // console.log('iframe')
            // console.log(iframe)
            var doc = null
            iframe.setAttribute('style', 'position:absolute;width:0;height:0;left:-500px;top:-500px;')

            document.body.appendChild(iframe)
            doc = iframe.contentWindow.document
            doc.write(content)
            doc.close()
            iframe.contentWindow.focus()

            iframe.contentWindow.addEventListener('load', function () {
                console.log('addEventListener')
                iframe.contentWindow.print()
                document.body.removeChild(iframe)
            })
            //window.document.body.innerHTML=content
            //window.print()
        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeEquipment(row)
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeEquipment(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/equipment/remove",
                data: {
                    id: row.id,
                    equipmentCode: row.equipmentCode,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.getAll()
            })
        },
        pageClick(currentPage) {
            this.orderProcessList = []

            this.pageIndex = (currentPage - 1) * this.pageNum
            this.getAll()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAll()
        },
    },
    mounted() {
        this.setDefaultPath('/equipmentManage')

        this.getAll()
    }
}
</script>

<style>
.el-pagination__total {
    color: green;
}
</style>